import React, { useState, useEffect } from "react";
import MapperTransactionReport from "../../components/MapperTransactionReport";
import TransactionSummary from "../../components/TransactionSummary";
import TransactionTypes from "../../components/TransactionTypes/TransactionTypes";
import TransactionReportInput from "../../components/TransactionReportInput";
import CsplDateRangePicker from "../../components/DateRangePicker/DateRangePicker";

import { YAxis } from "recharts";

import OtherTransactionReport from "../../components/OtherTransactionReport";
import { faSackDollar, faUser } from "@fortawesome/pro-solid-svg-icons";

import {
  getEmployeeTransactionReport,
  getPlanTransactionReport,
  getMapperTransactionReport,
} from "../../services";
import { LoaderWrapper } from "../../components";

const data3 = {
  "Pass-Through": {
    New: 123,
    Deleted: 22,
    Total: 143,
  },
  "Core-In": {
    New: 123,
    Deleted: 22,
    Total: 143,
  },
  "Core-Out": {
    New: 13,
    Deleted: 19,
    Total: 143,
  },
};

const data1 = {
  "Core-Out": {
    New: 13,
    Deleted: 19,
    Total: 143,
  },
};

const transdata = {
  TotalTransactions: 19,
  Active: 20,
  NewRequest: 15,
  Deleted: 20,
};

const data5 = {
  "Total loaned amount": "$ 23,234.90",
  "Total loans": "44",
  New: "12",
  Deleted: "23",
};

const data4 = [
  {
    category: "Loans",
    count: 20,
  },
  {
    category: "Transfers",
    count: 12,
  },
  {
    category: "Withdrawal",
    count: 24,
  },
  {
    category: "Rollover",
    count: 9,
  },
  {
    category: "Money-In",
    count: 6,
  },
  {
    category: "Money-Out",
    count: 0,
  },
];

const FullTransactionReportContainer = (props) => {
  const [TenantName, setTenantName] = useState("");
  const names = ["John", "Jane", "Alex", "Emily", "Mike"];
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [showSelectedRange, setShowSelectedRange] = useState(false);

  const [dataLoading, setDataLoading] = useState(false);
  const [anyErrors, setAnyErrors] = useState("No Data");

  const [planData, setPlanData] = useState({});
  const [employeeData, setEmployeeData] = useState({});
  const [mapperData, setMapperData] = useState({});
  const [transactionReportResponse, setTransactionReportResponse] = useState();

  const handleTenantNameChange = (event) => {
    setTenantName(event.target.value);
  };
  const toggleGoClear = () => {
    if (showSelectedRange) {
      setFromDate(null);
      setToDate(null);
      setTenantName("");
    }
    setShowSelectedRange((preState) => !preState);
  };

  useEffect(() => {
    const fetchData = async () => {
      setDataLoading(true);
      if (showSelectedRange && fromDate && toDate) {
        Promise.all([
          getPlanTransactionReport({ fromDate, toDate }),
          getEmployeeTransactionReport({ fromDate, toDate }),
          getMapperTransactionReport({ fromDate, toDate }),
        ])
          .then(
            ([
              PlanResponse,
              EmployeeResponse,
              MapperResponse,
              // TransactionReportResponse
            ]) => {
              setPlanData(PlanResponse);
              updatePlanData();
              setEmployeeData(EmployeeResponse);
              updateEmployeeData();
              setMapperData(MapperResponse);
              // setTransactionReportResponse(TransactionReportResponse)
              setDataLoading(false);
            }
          )
          .catch((error) => {
            setDataLoading(false);
            setAnyErrors(error);
            console.log("Error occurred while fetching data:", error);
          });
      }
    };

    if (showSelectedRange && fromDate && toDate) {
      fetchData();
    }
  }, [showSelectedRange, fromDate, toDate]);

  const updatePlanData = () => {
    setPlanData((prev) => ({ ...prev, title: "Plan", Icon: faSackDollar }));
  };
  const updateEmployeeData = () => {
    setEmployeeData((prev) => ({ ...prev, title: "Employee", Icon: faUser }));
  };

  console.log("Mapper Data: ", mapperData);

  const handleGoClick = (selectedFromDate, selectedToDate) => {
    setFromDate(selectedFromDate);
    setToDate(selectedToDate);
  };
  const getDifferenceInDays = (date1, date2) => {
    const differenceInTime = date2.getTime() - date1.getTime();
    const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
    return differenceInDays;
  };

  return (
    <div
      className="sidescroll"
      style={{
        flexGrow: "1",
        overflowY: "scroll",
        objectFit: "cover",
        height: "100vh",
        padding: "0 20px",
      }}
    >
      <div>
        <div
          style={{
            display: "flex",
            backgroundColor: "#F6F6F6",
            marginBottom: "20px",
            paddingLeft: "10px",
          }}
        >
          <div style={{ paddingRight: "24px" }}>
            <label
              style={{ fontSize: "14px", fontWeight: "600", color: "#7c7c70" }}
              htmlFor="name"
            >
              Tenant Name
            </label>
            <br></br>
            <select
              style={{
                width: "230px",
                height: "45px",
                borderRadius: "8px",
                border: "1px solid #ccc",
              }}
              id="name"
              value={TenantName}
              onChange={handleTenantNameChange}
            >
              <option value="">-- Select --</option>
              {names.map((name) => (
                <option key={name} value={name}>
                  {name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label
              style={{
                marginBottom: "0",
                color: "#7c7c70",
                fontSize: "14px",
                fontWeight: "600",
              }}
              htmlFor="name"
            >
              Select Date range
            </label>
            <div style={{ padding: "8px", display: "flex" }}>
              <CsplDateRangePicker
                fromDate={fromDate}
                toDate={toDate}
                onGoClick={handleGoClick}
              />
              {fromDate && toDate && (
                <button className="goButton" onClick={toggleGoClear}>
                  {showSelectedRange ? "Clear" : "Go"}
                </button>
              )}
            </div>
          </div>
        </div>
        {showSelectedRange && fromDate && toDate && TenantName && (
          <LoaderWrapper isLoading={dataLoading}>
            <>
              <div
                style={{ display: "flex", gap: "20px", marginBottom: "20px" }}
              >
                <div style={{ display: "flex", width: "30%", gap: "20px" }}>
                  <OtherTransactionReport data={planData} />
                  <OtherTransactionReport data={employeeData} />
                </div>
                <div style={{ width: "70%" }}>
                  <MapperTransactionReport data={mapperData} />
                </div>
              </div>
              <TransactionSummary transdata={transdata} />
              <TransactionTypes data={data4} data5={data5} />
            </>
          </LoaderWrapper>
        )}
      </div>
    </div>
  );
};
export default FullTransactionReportContainer;
